import React, { useState } from 'react';
import { authService } from '../../services/authService';
import './ForgotPassword.css';

interface ForgotPasswordProps {
  onBack?: () => void;
}

const ForgotPassword: React.FC<ForgotPasswordProps> = ({ onBack }) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setSubmitting(true);

    try {
      const res = await authService.forgotPassword(email.trim());
      setSuccess(res.message);
      setEmail('');
    } catch (err: unknown) {
      let msg = 'Не удалось отправить запрос. Попробуйте позже.';
      if (err && typeof err === 'object' && 'response' in err) {
        const res = (err as { response?: { data?: { message?: string; errors?: Record<string, string[]> } } }).response;
        const data = res?.data;
        if (data?.errors?.email?.length) {
          msg = data.errors.email[0];
        } else if (data?.message) {
          msg = data.message;
        }
      }
      setError(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-logo">
        <img src="/logo.svg" alt="A2K CRM" className="logo-image" />
      </div>

      <div className="login-card">
        <h1 className="login-title">Восстановление пароля</h1>

        <form onSubmit={handleSubmit} className="login-form">
          {error && (
            <div className="login-error" role="alert">
              {error}
            </div>
          )}
          {success && (
            <div className="login-success" role="status">
              {success}
            </div>
          )}

          <div className="form-group">
            <input
              type="email"
              placeholder="Ваш email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="form-input"
              required
              disabled={submitting}
            />
          </div>

          <button type="submit" className="login-button" disabled={submitting}>
            {submitting ? 'Отправка...' : 'Запросить восстановление'}
          </button>
        </form>

        <a
          href="#"
          className="forgot-password"
          onClick={(e) => {
            e.preventDefault();
            if (onBack) onBack();
          }}
        >
          Вернуться назад
        </a>
      </div>
    </div>
  );
};

export default ForgotPassword;
